const moment = require("moment");

export function reduceDataToByDay(data) {
  return data && data.length > 0
    ? Object.values(
        data?.reduce((r, { x, y }) => {
          let dateObj = new Date(x);
          let dayX = dateObj.toLocaleString("en-us", {
            day: "2-digit",
            month: "long",
            year: "numeric",
          });
          if (!r[dayX]) r[dayX] = { x: dayX, y };
          else r[dayX].y += y;
          return r;
        }, {})
      ).sort((a, b) => new Date(a.x) - new Date(b.x))
    : null;
}

export function reduceDataToByWeek(data) {
  if (data && data.length > 0) {
    const res = Object.values(
      data?.reduce((r, { x, y }) => {
        const key = moment(new Date(x)).startOf("week").format();
        if (!r[key]) r[key] = { x: key, y };
        else r[key].y += y;
        return r;
      }, {})
    );
    return res.sort((a, b) => new Date(a.x) - new Date(b.x));
  }
  return null;
}

export function reduceDataToByMonth(data) {
  return data && data.length > 0
    ? Object.values(
        data?.reduce((r, { x, y }) => {
          let dateObj = new Date(x);
          let monthYearX = dateObj.toLocaleString("en-us", {
            month: "long",
            year: "numeric",
          });
          if (!r[monthYearX]) r[monthYearX] = { x: monthYearX, y };
          else r[monthYearX].y += y;
          return r;
        }, {})
      ).sort((a, b) => new Date(a.x) - new Date(b.x))
    : null;
}

export function getTotal(arrayLine) {
  return arrayLine
    ?.map((l) => l.y)
    .reduce((prev, current) => prev + current, 0);
}

export function filterToLastTenHours(data) {
  if (data && data.length > 0) {
    const lastElementDate = new Date(data[data.length - 1].x);
    return data.filter(
      (o) => new Date(o.x).getTime() >= lastElementDate.getTime() - 43200000
    );
  } else {
    return null;
  }
}

export function filterToLastTenDays(data) {
  if (data && data.length > 0) {
    const lastElementDate = new Date(data[data.length - 1].x);
    return data.filter(
      (o) => new Date(o.x).getTime() >= lastElementDate.getTime() - 864000000
    );
  } else {
    return null;
  }
}

export function filterToLastTenWeeks(data) {
  if (data && data.length > 0) {
    const lastElementDate = new Date(data[data.length - 1].x);
    return data.filter(
      (o) => new Date(o.x).getTime() >= lastElementDate.getTime() - 6048000000
    );
  } else {
    return null;
  }
}

export function filterToLastSixMonths(data) {
  if (data && data.length > 0) {
    const lastElementDate = new Date(data[data.length - 1].x);
    return data.filter(
      (o) => new Date(o.x).getTime() >= lastElementDate.getTime() - 15778800000
    );
  } else {
    return null;
  }
}

export function getHoursDifference(d1, d2) {
  const msInHour = 1000 * 60 * 60;

  return Math.round(Math.abs(d2 - d1) / msInHour);
}

export const getDaysDifference = (d1, d2) => {
  let diff = d2.getTime() - d1.getTime();
  return Math.ceil(diff / (1000 * 3600 * 24));
};

export const getMonthsDifference = (d1, d2) => {
  let months = (d2.getFullYear() - d1.getFullYear()) * 12;
  months -= d1.getMonth();
  months += d2.getMonth();
  return months <= 0 ? 0 : months;
};

export function getWeeksDifference(d1, d2) {
  const msInWeek = 1000 * 60 * 60 * 24 * 7;

  return Math.round(Math.abs(d2 - d1) / msInWeek);
}
